'use client';

import { UpdateNotification } from '@uicwebmaster/user-notifications/components';
import { Button } from '@/components/ui/Button';

export function UpdateNotificationWrapper() {
  return (
    <UpdateNotification
      checkInterval={5 * 60 * 1000} // 5 minutes
      autoDismissAfter={0}
      ui={{ Button }}
    />
  );
}
